/**
 * Seam Quick Buy & Cart Drawer
 * Vanilla JS — no jQuery dependency
 */
(function () {
  'use strict';

  /* ── Settings ──────────────────────────────────────────── */
  const settingsEl = document.getElementById('seam-drawer-settings');
  if (!settingsEl) return;
  const S = JSON.parse(settingsEl.textContent);
  const moneyFmt = S.money_format || '{{amount}}';

  /* ── DOM refs ──────────────────────────────────────────── */
  const drawer   = document.getElementById('seam-drawer');
  const overlay  = document.getElementById('seam-drawer-overlay');
  const qbView   = document.getElementById('seam-drawer-qb');
  const cartView = document.getElementById('seam-drawer-cart');
  if (!drawer) return;

  /* ── State ─────────────────────────────────────────────── */
  let product       = null;   // current product JSON
  let selectedOpts  = [];     // ['200g', 'Whole Bean', ...]
  let quantity       = 1;
  let lastProductId  = null;  // for cross-sell

  /* ── Helpers ───────────────────────────────────────────── */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }

  function imgUrl(src, size) {
    if (!src) return '';
    return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)\./, '.')
              .replace(/\.([^.]*)$/, '_' + size + '.$1');
  }

  function postJSON(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function getJSON(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ── Drawer open / close ───────────────────────────────── */
  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function showView(view) {
    qbView.style.display   = view === 'qb'   ? '' : 'none';
    cartView.style.display = view === 'cart' ? '' : 'none';
  }

  /* ── Header cart badge sync ────────────────────────────── */
  function syncBadge(count) {
    document.querySelectorAll('[data-bind="itemCount"]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('[data-ajax-cart-trigger]').forEach(function (el) {
      if (count > 0) el.classList.add('has-cart-count');
      else el.classList.remove('has-cart-count');
    });
    // Update the seam header cart count badge
    document.querySelectorAll('[data-seam-cart-trigger] .seam-cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    // If there's no .seam-cart-count yet but count > 0, create one
    if (count > 0) {
      document.querySelectorAll('[data-seam-cart-trigger]').forEach(function (el) {
        if (!el.querySelector('.seam-cart-count')) {
          var span = document.createElement('span');
          span.className = 'seam-cart-count';
          span.textContent = count;
          el.appendChild(span);
        }
      });
    }
    // Sync existing theme AJAX cart if present
    if (window.PXUTheme && window.PXUTheme.jsAjaxCart && window.PXUTheme.jsAjaxCart.updateView) {
      try { window.PXUTheme.jsAjaxCart.updateView(); } catch (e) { /* silent */ }
    }
  }

  /* ── Variant logic ─────────────────────────────────────── */
  function findVariant() {
    if (!product) return null;
    return product.variants.find(function (v) {
      return product.options.every(function (_, i) {
        return selectedOpts[i] && v.options[i] === selectedOpts[i];
      });
    }) || null;
  }

  function isOptionAvailable(optIndex, value) {
    return product.variants.some(function (v) {
      if (!v.available) return false;
      if (v.options[optIndex] !== value) return false;
      return product.options.every(function (_, i) {
        if (i === optIndex) return true;
        return !selectedOpts[i] || v.options[i] === selectedOpts[i];
      });
    });
  }

  /* ── Quick Buy: render ─────────────────────────────────── */
  function renderQuickBuy(p) {
    product = p;
    selectedOpts = [];
    quantity = 1;

    // Pre-select first available variant's options
    var firstAvail = p.variants.find(function (v) { return v.available; });
    if (firstAvail) {
      selectedOpts = p.options.map(function (_, i) { return firstAvail.options[i]; });
    }

    var variant = findVariant();
    var featImg = (variant && variant.featured_image ? variant.featured_image.src : p.featured_image)
      || (p.images && p.images[0]) || '';

    var html = '';

    // Header
    html += '<div class="sd-qb__header">';
    html += '  <span class="sd-qb__title">Select your options</span>';
    html += '  <button class="sd__close" data-seam-close aria-label="Close">';
    html += '    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    html += '  </button>';
    html += '</div>';

    // Product info
    html += '<div class="sd-qb__product">';
    html += '  <div class="sd-qb__image"><img src="' + imgUrl(featImg, '200x200') + '" alt="' + escHtml(p.title) + '"></div>';
    html += '  <div class="sd-qb__info">';
    html += '    <p class="sd-qb__product-title">' + escHtml(p.title) + '</p>';
    html += '    <a href="' + p.url + '" class="sd-qb__more">Find out more &rarr;</a>';
    html += '  </div>';
    html += '</div>';

    // Scrollable options area
    html += '<div class="sd-qb__options-wrap">';

    // Quantity
    html += '<div class="sd-qb__row sd-qb__quantity-row">';
    html += '  <span class="sd-qb__label">Quantity:</span>';
    html += '  <div class="sd-qb__qty">';
    html += '    <button class="sd-qb__qty-btn" data-seam-qty="-1" aria-label="Decrease">&minus;</button>';
    html += '    <span class="sd-qb__qty-val" data-seam-qty-display>1</span>';
    html += '    <button class="sd-qb__qty-btn" data-seam-qty="1" aria-label="Increase">+</button>';
    html += '  </div>';
    html += '</div>';

    // Options
    p.options.forEach(function (opt, i) {
      var optLabel = typeof opt === 'string' ? opt : (opt.name || opt);
      var values = [];
      if (typeof opt === 'object' && opt.values) {
        values = opt.values;
      } else {
        p.variants.forEach(function (v) {
          if (values.indexOf(v.options[i]) === -1) values.push(v.options[i]);
        });
      }

      html += '<div class="sd-qb__row sd-qb__option" data-option-index="' + i + '">';
      html += '  <div class="sd-qb__option-header">';
      html += '    <span class="sd-qb__label">' + escHtml(optLabel) + ':</span>';

      if (values.length <= S.pill_max) {
        // Pill buttons
        html += '  <div class="sd-qb__pills">';
        values.forEach(function (val) {
          var active = selectedOpts[i] === val;
          var avail = isOptionAvailable(i, val);
          html += '<button class="sd-qb__pill' + (active ? ' is-active' : '') + (avail ? '' : ' is-unavailable') + '"';
          html += ' data-seam-option="' + i + '" data-seam-value="' + escAttr(val) + '"';
          html += '>' + escHtml(val) + '</button>';
        });
        html += '  </div>';
      } else {
        // Dropdown
        html += '  <div class="sd-qb__select-wrap">';
        html += '    <select class="sd-qb__select" data-seam-option-select="' + i + '">';
        values.forEach(function (val) {
          var sel = selectedOpts[i] === val ? ' selected' : '';
          html += '<option value="' + escAttr(val) + '"' + sel + '>' + escHtml(val) + '</option>';
        });
        html += '    </select>';
        html += '  </div>';
      }

      html += '  </div>'; // option-header

      // Price breakdown for size-type options (first option with varying prices)
      if (i === 0 && p.variants.length > 1) {
        var pricesByVal = {};
        values.forEach(function (val) {
          var matchingVariants = p.variants.filter(function (v) { return v.options[i] === val; });
          if (matchingVariants.length > 0) {
            pricesByVal[val] = matchingVariants[0].price;
          }
        });
        var prices = Object.values(pricesByVal);
        var hasDifferentPrices = prices.some(function (pr) { return pr !== prices[0]; });

        if (hasDifferentPrices) {
          html += '<div class="sd-qb__price-breakdown">';
          var maxPrice = Math.max.apply(null, prices);
          values.forEach(function (val) {
            var pr = pricesByVal[val];
            var line = escHtml(val) + ' &mdash; ' + formatMoney(pr);
            if (pr === maxPrice) {
              line += ' <span class="sd-qb__save">Best value</span>';
            }
            html += '<div class="sd-qb__price-line">' + line + '</div>';
          });
          html += '</div>';
        }
      }

      html += '</div>'; // sd-qb__option
    });

    html += '</div>'; // options-wrap

    // Add to cart button
    var price = variant ? formatMoney(variant.price) : '';
    var btnLabel = variant ? 'Add to cart - ' + price : 'Select options';
    var btnDisabled = !variant || !variant.available;

    html += '<div class="sd-qb__footer">';
    if (variant && !variant.available) {
      html += '<button class="sd-qb__add-btn" disabled>Sold out</button>';
    } else {
      html += '<button class="sd-qb__add-btn" data-seam-add-to-cart' + (btnDisabled ? ' disabled' : '') + '>' + btnLabel + '</button>';
    }
    html += '</div>';

    qbView.innerHTML = html;
    showView('qb');
    openDrawer();
  }

  function refreshQuickBuyUI() {
    if (!product) return;
    var variant = findVariant();

    // Update pills active/unavailable states
    qbView.querySelectorAll('[data-seam-option]').forEach(function (pill) {
      var idx = parseInt(pill.dataset.seamOption);
      var val = pill.dataset.seamValue;
      pill.classList.toggle('is-active', selectedOpts[idx] === val);
      pill.classList.toggle('is-unavailable', !isOptionAvailable(idx, val));
    });

    // Update dropdowns
    qbView.querySelectorAll('[data-seam-option-select]').forEach(function (sel) {
      var idx = parseInt(sel.dataset.seamOptionSelect);
      sel.value = selectedOpts[idx] || '';
    });

    // Update add button
    var btn = qbView.querySelector('[data-seam-add-to-cart]');
    if (btn) {
      if (!variant) {
        btn.disabled = true;
        btn.textContent = 'Select options';
      } else if (!variant.available) {
        btn.disabled = true;
        btn.textContent = 'Sold out';
      } else {
        btn.disabled = false;
        btn.textContent = 'Add to cart - ' + formatMoney(variant.price);
      }
    }

    // Update product image if variant has one
    if (variant && variant.featured_image) {
      var img = qbView.querySelector('.sd-qb__image img');
      if (img) img.src = imgUrl(variant.featured_image.src, '200x200');
    }
  }

  /* ── Cart view: render ─────────────────────────────────── */
  function showCartView() {
    showView('cart');
    cartView.innerHTML = '<div class="sd-cart__loading">Loading cart...</div>';
    openDrawer();

    getJSON('/cart.js').then(function (cart) {
      renderCart(cart);
      // Fetch cross-sell for last added product
      if (S.crosssell_enabled && lastProductId) {
        fetchCrossSell(lastProductId);
      }
    });
  }

  function renderCart(cart) {
    syncBadge(cart.item_count);

    var html = '';

    // Header — fixed at top
    html += '<div class="sd-cart__header">';
    html += '  <span class="sd-cart__title">Cart</span>';
    html += '  <button class="sd__close" data-seam-close aria-label="Close">';
    html += '    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    html += '    <span>Close</span>';
    html += '  </button>';
    html += '</div>';

    if (cart.item_count === 0) {
      html += '<div class="sd-cart__scroll"><div class="sd-cart__empty">Your cart is empty.</div></div>';
      cartView.innerHTML = html;
      return;
    }

    // Scrollable body
    html += '<div class="sd-cart__scroll">';

    // Items
    html += '<div class="sd-cart__items">';
    cart.items.forEach(function (item, idx) {
      html += '<div class="sd-cart__item" data-line="' + (idx + 1) + '">';
      html += '  <div class="sd-cart__item-img">';
      if (item.image) html += '<img src="' + imgUrl(item.image, '160x160') + '" alt="' + escHtml(item.product_title) + '">';
      html += '  </div>';
      html += '  <div class="sd-cart__item-details">';
      html += '    <p class="sd-cart__item-title">' + escHtml(item.product_title) + '</p>';
      if (item.variant_title) {
        html += '  <p class="sd-cart__item-variant">' + escHtml(item.variant_title).replace(/\s*\/\s*/g, ' &middot; ') + '</p>';
      }
      html += '    <div class="sd-cart__item-bottom">';
      html += '      <div class="sd-qb__qty">';
      html += '        <button class="sd-qb__qty-btn" data-seam-cart-qty="' + item.key + '" data-seam-delta="-1" aria-label="Decrease">&minus;</button>';
      html += '        <span class="sd-qb__qty-val">' + item.quantity + '</span>';
      html += '        <button class="sd-qb__qty-btn" data-seam-cart-qty="' + item.key + '" data-seam-delta="1" aria-label="Increase">+</button>';
      html += '      </div>';
      html += '      <span class="sd-cart__item-price">' + formatMoney(item.final_line_price) + '</span>';
      html += '    </div>';
      html += '  </div>';
      html += '  <button class="sd-cart__item-remove" data-seam-cart-remove="' + item.key + '" aria-label="Remove">';
      html += '    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      html += '  </button>';
      html += '</div>';
    });
    html += '</div>';

    // Cross-sell placeholder
    if (S.crosssell_enabled) {
      html += '<div id="sd-cart-crosssell"></div>';
    }

    // Optional note
    if (S.cart_note) {
      html += '<div class="sd-cart__note-toggle">';
      html += '  <button data-seam-note-toggle>';
      html += '    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>';
      html += '    <span>Add Optional Note</span>';
      html += '  </button>';
      html += '</div>';
      html += '<div class="sd-cart__note-area" style="display:none;">';
      html += '  <textarea class="sd-cart__note-input" data-seam-note-input placeholder="Special instructions..." rows="3">' + escHtml(cart.note || '') + '</textarea>';
      html += '</div>';
    }

    html += '</div>'; // end sd-cart__scroll

    // Footer — fixed at bottom
    html += '<div class="sd-cart__footer">';
    html += '  <div class="sd-cart__total">';
    html += '    <span>Total</span>';
    html += '    <span>' + formatMoney(cart.total_price) + '</span>';
    html += '  </div>';
    html += '  <a href="/checkout" class="sd-cart__checkout-btn">Checkout</a>';
    html += '</div>';

    cartView.innerHTML = html;
  }

  /* ── Cross-sell ────────────────────────────────────────── */
  function fetchCrossSell(productId) {
    var url = '/recommendations/products.json?product_id=' + productId + '&limit=' + S.crosssell_limit;
    getJSON(url).then(function (data) {
      var container = document.getElementById('sd-cart-crosssell');
      if (!container || !data.products || data.products.length === 0) return;

      var html = '<div class="sd-cart__crosssell">';
      html += '<p class="sd-cart__crosssell-heading">' + escHtml(S.crosssell_heading) + '</p>';

      data.products.forEach(function (rec) {
        var firstAvail = rec.variants.find(function (v) { return v.available; });
        if (!firstAvail) return;

        html += '<div class="sd-cart__rec">';
        html += '  <div class="sd-cart__rec-img">';
        if (rec.featured_image) html += '<img src="' + imgUrl(rec.featured_image, '80x80') + '" alt="' + escHtml(rec.title) + '">';
        html += '  </div>';
        html += '  <div class="sd-cart__rec-info">';
        html += '    <p class="sd-cart__rec-title">' + escHtml(rec.title) + '</p>';
        html += '    <p class="sd-cart__rec-price">' + formatMoney(firstAvail.price) + '</p>';
        html += '  </div>';
        html += '  <button class="sd-cart__rec-add" data-seam-rec-add="' + firstAvail.id + '" data-seam-rec-product="' + rec.id + '">Add</button>';
        html += '</div>';
      });

      html += '</div>';
      container.innerHTML = html;
    }).catch(function () { /* silent */ });
  }

  /* ── Escape helpers ────────────────────────────────────── */
  function escHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function escAttr(str) {
    return escHtml(str);
  }

  /* ── Event delegation ──────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var target = e.target;

    // Close button
    if (target.closest('[data-seam-close]')) {
      closeDrawer();
      return;
    }

    // Overlay close
    if (target === overlay) {
      closeDrawer();
      return;
    }

    // Quick Add button click → open quick buy drawer
    var quickAddBtn = target.closest('.sfp-quick-add');
    if (quickAddBtn && !quickAddBtn.classList.contains('sfp-quick-add--notify')) {
      var card = quickAddBtn.closest('[data-seam-quick-buy]');
      if (!card) return;

      e.preventDefault();
      e.stopPropagation();

      var handle = card.dataset.seamQuickBuy;
      var hasOnlyDefault = card.dataset.seamHasOnlyDefault === 'true';
      var defaultVarId = card.dataset.seamDefaultVariant;
      var prodId = card.dataset.seamProductId;

      lastProductId = prodId;

      if (hasOnlyDefault && defaultVarId) {
        // No variants — add directly to cart
        postJSON('/cart/add.js', { id: parseInt(defaultVarId), quantity: 1 }).then(function () {
          showCartView();
        });
      } else {
        // Has variants — fetch product and show quick buy
        getJSON('/products/' + handle + '.js').then(function (p) {
          lastProductId = p.id;
          renderQuickBuy(p);
        });
      }
      return;
    }

    // Quick Buy: pill option click
    var pill = target.closest('[data-seam-option]');
    if (pill && qbView.contains(pill)) {
      var idx = parseInt(pill.dataset.seamOption);
      selectedOpts[idx] = pill.dataset.seamValue;
      refreshQuickBuyUI();
      return;
    }

    // Quick Buy: quantity buttons
    var qtyBtn = target.closest('[data-seam-qty]');
    if (qtyBtn && qbView.contains(qtyBtn)) {
      var delta = parseInt(qtyBtn.dataset.seamQty);
      quantity = Math.max(1, quantity + delta);
      var display = qbView.querySelector('[data-seam-qty-display]');
      if (display) display.textContent = quantity;
      return;
    }

    // Quick Buy: add to cart
    if (target.closest('[data-seam-add-to-cart]')) {
      var v = findVariant();
      if (!v || !v.available) return;

      var addBtn = target.closest('[data-seam-add-to-cart]');
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      postJSON('/cart/add.js', { id: v.id, quantity: quantity }).then(function () {
        showCartView();
      }).catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = 'Error — try again';
      });
      return;
    }

    // Cart: quantity buttons
    var cartQty = target.closest('[data-seam-cart-qty]');
    if (cartQty) {
      var key = cartQty.dataset.seamCartQty;
      var d = parseInt(cartQty.dataset.seamDelta);
      var qtyEl = cartQty.parentElement.querySelector('.sd-qb__qty-val');
      var currentQty = parseInt(qtyEl.textContent);
      var newQty = Math.max(0, currentQty + d);

      postJSON('/cart/change.js', { id: key, quantity: newQty }).then(function (cart) {
        renderCart(cart);
        if (S.crosssell_enabled && lastProductId) fetchCrossSell(lastProductId);
      });
      return;
    }

    // Cart: remove item
    var removeBtn = target.closest('[data-seam-cart-remove]');
    if (removeBtn) {
      var rkey = removeBtn.dataset.seamCartRemove;
      postJSON('/cart/change.js', { id: rkey, quantity: 0 }).then(function (cart) {
        renderCart(cart);
        if (S.crosssell_enabled && lastProductId) fetchCrossSell(lastProductId);
      });
      return;
    }

    // Cross-sell: add recommendation
    var recAdd = target.closest('[data-seam-rec-add]');
    if (recAdd) {
      var recId = parseInt(recAdd.dataset.seamRecAdd);
      recAdd.disabled = true;
      recAdd.textContent = 'Added';

      postJSON('/cart/add.js', { id: recId, quantity: 1 }).then(function () {
        getJSON('/cart.js').then(function (cart) {
          renderCart(cart);
          if (S.crosssell_enabled && lastProductId) fetchCrossSell(lastProductId);
        });
      });
      return;
    }

    // Note toggle
    if (target.closest('[data-seam-note-toggle]')) {
      var noteArea = document.querySelector('.sd-cart__note-area');
      if (noteArea) {
        noteArea.style.display = noteArea.style.display === 'none' ? '' : 'none';
        var input = noteArea.querySelector('textarea');
        if (input && noteArea.style.display !== 'none') input.focus();
      }
      return;
    }

    // Cart trigger in header → open cart drawer
    var cartTrigger = target.closest('[data-seam-cart-trigger]') || target.closest('[data-ajax-cart-trigger]');
    if (cartTrigger && S.enabled) {
      e.preventDefault();
      e.stopPropagation();
      lastProductId = null;
      showCartView();
      return;
    }
  });

  // Quick Buy: dropdown option change
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-seam-option-select]');
    if (sel && qbView.contains(sel)) {
      var idx = parseInt(sel.dataset.seamOptionSelect);
      selectedOpts[idx] = sel.value;
      refreshQuickBuyUI();
    }
  });

  // Note input: save on blur
  document.addEventListener('focusout', function (e) {
    if (e.target.matches('[data-seam-note-input]')) {
      postJSON('/cart/update.js', { note: e.target.value });
    }
  });

  // Escape key closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

})();
